export default {
  finalHomeTitle (state, getters, rootState) {
    if (rootState.lang === 'vn') {
      return state.homeTitle[0]
    } else {
      return state.homeTitle[1]
    }
  },
  // Banner
  finalBannerImages (state) {
    return state.bannerImages
  },
  // Column 1
  finalCl1Title (state, getters, rootState) {
    if (rootState.lang === 'vn') {
      return state.cl1Title[0]
    } else {
      return state.cl1Title[1]
    }
  },
  finalLoginBox (state, getters, rootState) {
    if (rootState.lang === 'vn') {
      return state.vnLoginBox
    } else {
      return state.enLoginBox
    }
  },
  // Column 2
  finalIntroBox (state, getters, rootState) {
    if (rootState.lang === 'vn') {
      return state.vnCl2Content
    } else {
      return state.enCl2Content
    }
  },
  // Info Box
  finalHomeNews (state, getters, rootState) {
    if (rootState.lang === 'vn') {
      return state.vnHomeNews
    } else {
      return state.enHomeNews
    }
  },
  finalHomeServices (state, getters, rootState) {
    if (rootState.lang === 'vn') {
      return state.vnHomeServices
    } else {
      return state.enHomeServices
    }
  },
  finalInfoBoxTitle1 (state, getters, rootState) {
    if (rootState.lang === 'vn') {
      return state.vnInfoBoxTitle[0]
    } else {
      return state.enInfoBoxTitle[0]
    }
  },
  finalInfoBoxTitle2 (state, getters, rootState) {
    if (rootState.lang === 'vn') {
      return state.vnInfoBoxTitle[1]
    } else {
      return state.enInfoBoxTitle[1]
    }
  }
}
